import React, { Component } from 'react';
import PropTypes from 'prop-types';
import amp from 'lib/amp';

@amp((props) => (
  <amp-img
    src={props.src}
    alt={props.alt}
    width={props.minWidth ? props.minWidth : 100}
    height={props.minHeight ? props.minHeight : 100}
    layout={props.layout ? props.layout : 'responsive'}
  />
))
class RawImage extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    minWidth: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
    minHeight: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
    layout: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    className: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  };

  static defaultProps = {
    alt: null,
    minWidth: 100,
    minHeight: 100,
    layout: 'responsive',
    className: null,
  };

  render() {
    const { src, alt, className } = this.props;
    return <img src={src} alt={alt} className={className} />;
  }
}

export default RawImage;
